
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"21","height":"21","viewBox":"0 0 21 21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.73337 16.3333V16.4333H3.83337H17.1667H17.2667V16.3333V15.0833V14.9833H17.1667H15.5375V8.70829C15.5375 7.52016 15.1834 6.46054 14.4754 5.53303C13.7827 4.62567 12.8786 4.04544 11.7667 3.7944V3.27079C11.7667 2.92418 11.641 2.63308 11.3902 2.40513C11.142 2.17949 10.8435 2.06663 10.5 2.06663C10.1566 2.06663 9.85806 2.17949 9.60986 2.40513C9.35911 2.63308 9.23337 2.92418 9.23337 3.27079V3.7944C8.12156 4.04546 7.22077 4.62578 6.53484 5.53342C5.8339 6.46093 5.48337 7.52041 5.48337 8.70829L5.48337 14.9833H3.83337H3.73337V15.0833V16.3333ZM8.83337 17.0666H8.73337V17.1666C8.73337 17.6524 8.91125 18.0703 9.26341 18.4152C9.6144 18.7588 10.028 18.9333 10.5 18.9333C10.9851 18.9333 11.4028 18.7594 11.7478 18.4144C12.0928 18.0694 12.2667 17.6517 12.2667 17.1666V17.0666H12.1667H8.83337ZM14.0875 14.9833H6.93337L6.93337 8.70829C6.93337 7.70654 7.28084 6.85692 7.97734 6.15366C8.6736 5.45064 9.51945 5.09996 10.5209 5.09996C11.5223 5.09996 12.3645 5.45061 13.0536 6.15331C13.7433 6.85651 14.0875 7.70623 14.0875 8.70829V14.9833Z","fill":"#4A3428","stroke":"#4A3428","stroke-width":"0.2"}})])
          )
        }
      }
    